// extracted by mini-css-extract-plugin
export var buttonContainer = "_2v-6";
export var centeredToolbar = "_2v-4";
export var dashdraw = "_2v-c";
export var emptyStateContainer = "_2v-8";
export var emptyStateText = "_2v-9";
export var flowEditor = "_2v-0";
export var flowEditorContainer = "_2v-7";
export var hovered = "_2v-1";
export var leftPanel = "_2v-3";
export var mainCanvasContainer = "_2v-a";
export var minimap = "_2v-b";
export var selectMode = "_2v-2";
export var toolbarSeparator = "_2v-5";